import { RefObject } from 'react';

import type { TAppliedRanges } from '@app/dashboard/types/innerLayout/date-ranges';

export const extractCampaignMetrics = (campaignAnalysis?: any) => {
  const data = campaignAnalysis?.data?.data;

  return {
    campaign_count: Number(data?.campaign_count) || 0,
    sent_campaigns: Number(data?.sent_campaigns) || 0,
    total_phone_numbers: Number(data?.total_phone_numbers) || 0,
    unsent_campaigns: Number(data?.unsent_campaigns) || 0,
  };
};

export const buildCampaignEventPayload = (
  metrics: ReturnType<typeof extractCampaignMetrics>,
  propKey: any
) => ({
  [propKey.TOTAL_CUSTOMERS]: metrics.total_phone_numbers,
  [propKey.TOTAL_CAMPAIGNS]: metrics.campaign_count,
  [propKey.SUCCESS_SMS]: metrics.sent_campaigns,
  [propKey.FAIL_SMS]: metrics.unsent_campaigns,
});

export const checkIfPrevDateRangeEqualToCurrent = ({
  prevDateSelected,
  appliedRanges,
}: {
  prevDateSelected: RefObject<TAppliedRanges>;
  appliedRanges: TAppliedRanges;
}) => {
  return (
    prevDateSelected.current?.start === appliedRanges.start &&
    prevDateSelected.current?.end === appliedRanges.end
  );
};
